import { AddUserToCompanyFromAdminProps } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function addUserToCompanyFromAdmin(
  companyId: number,
  user: AddUserToCompanyFromAdminProps
): Promise<Response> {
  const res = await fetcher(`company/${companyId}/member/admin`, {
    method: 'POST',
    body: user,
  });

  return res;
}
